import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Dark mode CSS override for Bootstrap
const darkModeCSS = `
  .dark-theme .card,
  .dark-theme .modal-content,
  .dark-theme .dropdown-menu,
  .dark-theme .list-group-item {
    background-color: #1e1e1e;
    color: #e0e0e0;
    border-color: #424242;
  }
  
  .dark-theme .form-control,
  .dark-theme .form-select,
  .dark-theme input,
  .dark-theme select,
  .dark-theme textarea {
    background-color: #1e1e1e;
    color: #e0e0e0;
    border-color: #424242;
  }
  
  .dark-theme .table {
    color: #e0e0e0;
  }
  
  .dark-theme .table-striped > tbody > tr:nth-of-type(odd) {
    background-color: #1a1a1a;
  }
  
  .dark-theme .table thead th {
    background-color: #2d2d2d;
    border-bottom: 2px solid #424242;
  }
  
  .dark-theme .card-header {
    background-color: #2d2d2d;
  }
  
  .dark-theme .pagination .page-link {
    background-color: #1e1e1e;
    border-color: #424242;
    color: #e0e0e0;
  }
  
  .dark-theme .pagination .page-item.active .page-link {
    background-color: #5c6bc0;
    border-color: #5c6bc0;
    color: white;
  }
  
  .dark-theme .text-muted {
    color: #bdbdbd !important;
  }
  
  .dark-theme .badge {
    border: none;
  }
  
  .dark-theme .border {
    border-color: #424242 !important;
  }
  
  .dark-theme .dropdown-item:hover, 
  .dark-theme .dropdown-item:focus {
    background-color: #333333;
    color: #e0e0e0;
  }
  
  .dark-theme .btn-close {
    filter: invert(1) grayscale(100%) brightness(200%);
  }
`;

// Set CSS variable for viewport height to handle mobile browser UI
const setVhVariable = () => {
  // First we get the viewport height and we multiply it by 1% to get a value for a vh unit
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  
  // Handle iOS safe area insets (notches, home indicator)
  if (CSS && CSS.supports && CSS.supports('padding: env(safe-area-inset-bottom)')) {
    // Wait for the window to finish rendering before calculating
    setTimeout(() => {
      // Apply additional adjustments for iOS fullscreen mode
      document.body.style.paddingBottom = 'env(safe-area-inset-bottom)';
      document.body.style.paddingTop = 'env(safe-area-inset-top)';
    }, 300);
  }
};

// Add dark mode CSS override
const addDarkModeStyles = () => {
  const styleEl = document.createElement('style');
  styleEl.type = 'text/css';
  styleEl.appendChild(document.createTextNode(darkModeCSS));
  document.head.appendChild(styleEl);
};

// Set the variable initially
setVhVariable();
// Add dark mode styles
addDarkModeStyles();

// Update on resize and orientation change
window.addEventListener('resize', setVhVariable);
window.addEventListener('orientationchange', setVhVariable);
// Also update when the page becomes visible (user returns from another tab)
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    setVhVariable();
  }
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
